// دليل العملاء: الأشخاص الذين أتموا تسجيل الوصول أو لديهم بيانات فوترة.
export const clientesDir = {
  title: "العملاء",
  subtitle: "جميع الأشخاص الذين أتموا تسجيل الوصول (check-in) أو لديهم بيانات فوترة. يتم حفظهم تلقائياً دون تكرار.",
  searchLabel: "البحث عن عميل",
  searchPlaceholder: "الاسم أو الوثيقة أو البريد الإلكتروني أو الهاتف",
  filters: {
    todos: "الكل",
    checkin: "مع check-in",
    fiscal: "مع بيانات ضريبية",
    reservas: "مع حجوزات",
  },
  cols: {
    client: "العميل",
    document: "الوثيقة",
    phone: "الهاتف",
    stays: "الإقامات",
    lastStay: "آخر إقامة",
  },
  checkins: "{n} check-in | {n} check-in",
  bookings: "{n} حجز | {n} حجوزات",
  fiscalBadge: "ضريبي",
  noDocument: "بدون وثيقة",
  noName: "بدون اسم",
  emptyTitle: "لا يوجد عملاء بعد",
  emptyText: "كل من يُكمل check-in سيظهر هنا تلقائياً.",
  emptySearch: "لا يوجد عميل مطابق لـ «{q}».",
  loadError: "تعذّر تحميل العملاء.",
  pageOf: "{from}–{to} من {total}",
  prev: "السابق",
  next: "التالي",
  docTypes: {
    P: "جواز سفر",
    ID: "بطاقة الهوية الوطنية",
    IM: "NIE",
    I: "بطاقة هوية",
    D: "بطاقة الهوية الوطنية",
    N: "NIE",
    X: "تصريح إقامة",
    CC: "بطاقة المواطنة",
    CE: "بطاقة الأجنبي",
    TI: "بطاقة تعريف",
    PPT: "PPT",
    PEP: "PEP",
  },
  sheet: {
    close: "إغلاق",
    createBooking: "إنشاء حجز",
    personal: "البيانات الشخصية",
    document: "الوثيقة",
    address: "العنوان",
    fiscal: "البيانات الضريبية",
    noFiscal: "لا توجد بيانات ضريبية. تُضاف عند إصدار الفاتورة أو من الفوترة ← العملاء الضريبيون.",
    defaultProfile: "افتراضي",
    bookings: "الحجوزات",
    noBookings: "لا توجد حجوزات مرتبطة.",
    companions: "سافر مع",
    noCompanions: "لم يشارك حجزاً مع أي شخص آخر.",
    timesTogether: "{n} مرة | {n} مرات",
    invoices: "الفواتير",
    noInvoices: "لا توجد فواتير.",
    viewPdf: "عرض PDF",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    birthDate: "تاريخ الميلاد",
    sex: "الجنس",
    nationality: "الجنسية",
    docType: "النوع",
    docNumber: "الرقم",
    expiry: "تاريخ الانتهاء",
    support: "رقم الدعم",
    street: "العنوان",
    zip: "الرمز البريدي",
    city: "المدينة",
    country: "بلد الإقامة",
    roleCheckin: "Check-in",
    roleHolder: "صاحب الوثيقة",
    loadError: "تعذّر فتح ملف العميل.",
  },
  sexes: {
    M: "ذكر",
    F: "أنثى",
  },
  picker: {
    missingPolice: "لا توجد بيانات شرطة محفوظة لهذا العميل في هذا الحساب. أكملها الآن وستبقى للمرة القادمة.",
    searchSaved: "البحث عن عميل محفوظ",
    searchPlaceholder: "الاسم أو الوثيقة أو الهاتف…",
    noResults: "لا يوجد عميل محفوظ مطابق.",
    selected: "تمت تعبئة البيانات من العملاء",
    clear: "إزالة",
  },
  match: {
    title: "هذا العميل موجود بالفعل",
    text: "{name} محفوظ بالفعل في العملاء. يمكنك تعبئة جميع بياناته بلمسة واحدة.",
    use: "استخدام بياناته",
    dismiss: "ليس هذا الشخص",
    applied: "تمت تعبئة بيانات {name}. راجع تواريخ الإقامة ووقّع.",
    companionsTitle: "سافر سابقاً مع",
    companionsHint: "المس شخصاً لتسجيله ببياناته.",
    registerCompanion: "تسجيل {name}",
  },
};
